import React from 'react';
import { Link } from 'react-router-dom';

const features = [
  { title: 'QR Locations', text: 'Place QR codes at every touchpoint for instant access.' },
  { title: 'Instant Ticket', text: 'Visitors raise tickets in seconds—no app install.' },
  { title: 'Dashboard', text: 'Admins see workload, trends, and resolution metrics.' },
  { title: 'Ratings', text: 'Capture satisfaction with simple 1–5 star feedback.' },
  { title: 'Priority', text: 'Route urgent issues first with clear priority levels.' },
  { title: 'Analytics', text: 'Charts for trends, categories, and top locations.' },
];

const steps = ['Create Location', 'Generate QR', 'Visitor Scans', 'Submit Ticket', 'Admin Resolves'];

export default function LandingPage() {
  return (
    <div style={{ background: '#fff' }}>
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '1rem 1.5rem',
          maxWidth: 1200,
          margin: '0 auto',
          borderBottom: '1px solid var(--border)',
        }}
      >
        <Link to="/" style={{ fontWeight: 800, fontSize: '1.25rem', color: 'var(--primary)', textDecoration: 'none' }}>
          Ticket Rising
        </Link>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <Link to="/login" className="tr-btn tr-btn-ghost">
            Sign In
          </Link>
          <Link to="/login" className="tr-btn tr-btn-primary">
            Get Started
          </Link>
        </div>
      </header>

      <section
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '4rem 1.5rem',
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)', marginBottom: '1rem', lineHeight: 1.15 }}>
          Visitor feedback &amp; tickets, powered by QR
        </h1>
        <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem', maxWidth: 560, margin: '0 auto 2rem' }}>
          Scan, submit, resolve. Ticket Rising connects on-site visitors with your team through simple QR flows and a
          powerful admin dashboard.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/login" className="tr-btn tr-btn-primary" style={{ padding: '0.85rem 1.5rem' }}>
            Admin Login
          </Link>
          <Link to="/login" className="tr-btn tr-btn-outline" style={{ padding: '0.85rem 1.5rem' }}>
            Visitor Register
          </Link>
        </div>
      </section>

      <section style={{ background: 'var(--bg-muted)', padding: '3rem 1.5rem' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Features</h2>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
              gap: '1.25rem',
            }}
          >
            {features.map((f) => (
              <div key={f.title} className="tr-card" style={{ padding: '1.25rem' }}>
                <h3 style={{ marginTop: 0, color: 'var(--primary)' }}>{f.title}</h3>
                <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '0.95rem' }}>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: '3rem 1.5rem', maxWidth: 1200, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>How It Works</h2>
        <div
          style={{
            display: 'flex',
            gap: '1rem',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'stretch',
          }}
        >
          {steps.map((label, i) => (
            <div
              key={label}
              style={{
                flex: '1 1 140px',
                maxWidth: 200,
                textAlign: 'center',
                padding: '1rem',
                background: 'var(--primary-soft)',
                borderRadius: 'var(--radius)',
                border: '1px solid var(--border)',
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '50%',
                  background: 'var(--primary)',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 700,
                  margin: '0 auto 0.5rem',
                }}
              >
                {i + 1}
              </div>
              <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{label}</div>
            </div>
          ))}
        </div>
      </section>

      <section
        style={{
          background: 'var(--primary)',
          color: '#fff',
          padding: '2.5rem 1.5rem',
          textAlign: 'center',
        }}
      >
        <h2 style={{ marginTop: 0 }}>Ready to streamline on-site feedback?</h2>
        <p style={{ opacity: 0.95, marginBottom: '1.5rem' }}>Create locations, print QR codes, and start collecting tickets today.</p>
        <Link to="/login" className="tr-btn" style={{ background: '#fff', color: 'var(--primary)' }}>
          Open Login
        </Link>
      </section>

      <section style={{ padding: '2rem 1.5rem', maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
        <h3 style={{ marginBottom: '0.5rem' }}>Demo credentials</h3>
        <p style={{ color: 'var(--text-muted)', margin: 0 }}>
          <strong>Admin:</strong> admin@ticketrising.com / Admin@123
        </p>
      </section>

      <footer style={{ borderTop: '1px solid var(--border)', padding: '1.5rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.9rem' }}>
        © {new Date().getFullYear()} Ticket Rising. All rights reserved.
      </footer>
    </div>
  );
}
